export default __webpack_public_path__ + "static/media/intellipro4.4cb37762.png";